import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarMetodoConfiguracion } from '../../../actions/configuracion';

const EliminarMetodo = ({ metodo, reestablecerMetodo }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar metodo */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarMetodoConfiguracion(metodo?.id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerMetodo(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(metodo){
            setEliminarModal(true);
        }
    }, [metodo]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar metodo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar a {metodo?.nombre}{metodo?.empresas > 0 ? ' con ' + metodo?.empresas + ' relacionadas' : ''}? Ten en cuenta que si hay productos que tengan dependencia de esta metodo se les quitará.</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarMetodo;